const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

export const getExportTableEndpoint = (slug: string | null): string => {
  return `${BASE_URL}v1/third-party/export-tables/${slug}`
}
